export default class CouponsInfo {

    constructor(data) {
        this.data = data;
    }

    get suggestion(){
        return this.data && this.data.hasOwnProperty('suggestion') ? this.data.suggestion : null;
    }

}